import clsx from 'clsx';
import Script from 'next/script';
import { useEffect } from 'react';
import styles from './WrittenReviews.module.scss';

export const WrittenReviews = () => {
  useEffect(() => {
    if (window.yotpo && typeof window.yotpo.refreshWidgets === 'function') {
      setTimeout(() => {
        window.yotpo.refreshWidgets();
      }, 0);
    }
  }, []);

  return (
    <div className={clsx(styles.writtenReviews)}>
      <div id="reviews">
        <Script
          id="yotpo-script"
          src="https://staticw2.yotpo.com/hIb2q9LTvVqywBzsrNpaKLKn0QZ0GhVXjh9OQ7cM/widget.js"
        />
        <div
          className="yotpo yotpo-main-widget"
          data-product-id="6583801675874"
          data-name="Athletic Greens Ultimate Daily"
          data-url="https://drinkag1.com"
          data-image-url="https://athletic-greens.cdn.prismic.io/athletic-greens/452a0e8b2daa9b5b52610f44746bcedcbf3e0129_section-18-image-1.png"
          role="button"
          aria-label="Click to view more"
        />
      </div>
    </div>
  );
};
